export enum ECampaignStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  FINISHED = 'FINISHED',
  PAUSED = 'PAUSED',
  FAILED = 'FAILED',
}
